import React, { useState, useRef, useEffect, useCallback } from "react";
import { DayStyles } from "styles/global-style";

import ellipseleft from "imgs/ellipse-left.png";
import ellipseright from "imgs/ellipse-right.png";

export default function Dot({ size, space_y, disabled, callback, data, row, selected, canShowPopup, isFirstOrLast, canEdit, startDragJoinLeaveDayCb }) {
  const [hovering, setHovering] = useState(false);
  const [down, setDown] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const showPopupRef = useRef(false);
  const containerRef = useRef();

  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  const onClick = useCallback(
    (e) => {
      if (!canEdit) return;
      e.stopPropagation();
      if (callback) callback(data, e);
      setShowPopup(!showPopupRef.current);
    },
    [setShowPopup, callback, data, canEdit]
  );

  const handleMouseEnter = (e) => {
    e.stopPropagation();
    if (!canEdit || disabled) return;
    setHovering(true);
  };

  const handleMouseLeave = () => {
    if (!canEdit || disabled) return;
    setDown(false);
    setHovering(false);
  };

  const handleMouseUp = useCallback(
    (e) => {
      if (!canEdit || disabled) return;
      e.preventDefault();
      setDown(false);
    },
    [setDown, disabled, canEdit]
  );

  const handleMouseDown = useCallback(
    (e) => {
      if (!canEdit || disabled) return;
      e.preventDefault();
      if (isFirstOrLast) {
        const rect = containerRef.current.getBoundingClientRect();
        const xOffset = e.clientX - rect.left;
        startDragJoinLeaveDayCb(data.day, xOffset);
      }
      setDown(true);
    },
    [containerRef, isFirstOrLast, disabled, startDragJoinLeaveDayCb, setDown, data, canEdit]
  );

  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  useEffect(() => {
    showPopupRef.current = showPopup;
  }, [showPopup, showPopupRef]);

  useEffect(() => {
    if (!selected) setShowPopup(false);
  }, [selected]);

  const color = selected ? DayStyles.selected.color : data.style ? DayStyles[data.style].color : "limegreen";
  
  // Week-mode dots are two columns wide
  const dotWidth = data.isWeekMode ? size * 2 : size;
  
  // Use yOffset if provided (for grouped rendering), otherwise use row calculation
  const topPosition = data.yOffset !== undefined ? data.yOffset : row * (size + space_y);

  return (
    <>
      <div
        ref={containerRef}
        className="dot"
        style={{
          position: "absolute",
          left: data.pos.left,
          top: topPosition,
          background: color,
          width: dotWidth,
          height: size,
          border: DayStyles[data.style]?.border && !selected ? DayStyles[data.style]?.border : "none",
          borderRadius: 3,
          cursor: canEdit ? "pointer" : "initial",
          outline: hovering ? "2px solid white" : "none",
          boxSizing: "border-box",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          transform: down ? "scale(0.95)" : "scale(1)",
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onClick={onClick}
      >
        {selected && <img alt="selectedIcon" src={DayStyles.selected.icon} style={{ height: "40%", opacity: 0.5 }} />}
        {data.isWeekMode && data.workingDays > 0 && (
          <div style={{ 
            fontSize: "8px", 
            color: "white", 
            fontWeight: "bold",
            textAlign: "center",
            lineHeight: "1"
          }}>
            {data.workingDays}/{data.totalDays}
          </div>
        )}
      </div>

      {hovering && isFirstOrLast && (
        <div style={{ position: "absolute", left: data.pos.left, top: topPosition, zIndex: 100 }}>
          <div style={{ position: "absolute", left: -10, top: -2 }}>
            <img alt="ellipse-left" src={ellipseleft} style={{ height: 10, filter: "invert(1)" }} />
          </div>
          <div style={{ position: "absolute", left: 20, top: -2 }}>
            <img alt="ellipse-right" src={ellipseright} style={{ position: "absolute", top: 5, height: 10, filter: "invert(1)" }} />
          </div>
        </div>
      )}

    </>
  );
}
